import { render, staticRenderFns } from "./TransferToNewDialog.vue?vue&type=template&id=5601dd7b&"
import script from "./TransferToNewDialog.vue?vue&type=script&lang=js&"
export * from "./TransferToNewDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports